import React, { useEffect, useRef, useState } from 'react'
import './archived-games-container.styles.scss';
import AgeCheck from '@/components/layout-auth/age-check/age-check.component';
import { useSelector } from 'react-redux';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import { getGameDataFromDb } from '@/utils/getDataFromDb';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { membershipRestrictions } from '@/utils/membershipRestrictions';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import { UseCloudFunction } from '@/utils/firebase.utils';

const ArchivedGamesContainer = ({
  archivedList,
  managingList
}) => {

  const membership = useSelector(state => state.userData.membership);
  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [gamesToDisplay, setGamesToDisplay] = useState([]);
  const [alertMessage, setAlertMessage] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const gamesRef = useRef({});
  const approveRef = useRef(() => { });

  useEffect(() => {
    Object.values(archivedList).map(game => {
      console.log(game);
      getGameData(game);
    })
  }, [archivedList])


  function getGameData(game) {
    getGameDataFromDb({
      'gameId': game.gameId,
      'once': true,
      'callback': callback,
    })

    function callback(gameData) {
      gamesRef.current = {
        ...gamesRef.current,
        [gameData.gameId]: gameData
      }
      setGamesToDisplay(Object.values(gamesRef.current));
    }
  }

  function reinstateGame(gameId) {
    const gameCount = membershipRestrictions[membership.membership]?.gameCount;
    console.log(gameCount);
    if (managingList && Object.keys(managingList).length >= gameCount) {
      setAlertMessage(`You can only manage up to ${gameCount} active games.`);
      return;
    }
    setConfirmMessage('Are you sure you want to reinstate this game?');
    approveRef.current = () => {
      continueReinstatement(gameId);
    };

    async function continueReinstatement(gameId) {
      setLoading(true);
      const tempGameData = { ...gamesRef.current[gameId] };
      if (!tempGameData) {
        setAlertMessage('No Game Data found.');
        return;
      }
      console.log(tempGameData);
      const now = new Date().getTime();
      tempGameData.status = 'active';
      tempGameData.ts_reinstated = now;
      tempGameData.ts = now;
      const res = await UseCloudFunction(
        'saveGame',
        {
          'gameObj': tempGameData,
          'profile': userProfile,
          'appId': userProfile.appId,
          'action': 'reinstated'
        });
      if (res.error) {
        setAlertMessage(`Something went wrong. ` +
          `Please try again. (Error: ${res.error})`);
      } else {
        navigate(`/manage/${tempGameData.path}`);
      }
    }
  }

  return (
    <div className='archived-games-container'>
      <AgeCheck />
      {/* <Layout> */}
      <div className={`archived-games-content ${screenSize}`}>
        <div className={`g-card`}>
          <BackButton cancel={() => navigate(-1)} />
          <div className="g-space-1"></div>
          <div className='section-title'>
            Archived Games
          </div>
          <hr />
          <div className={`archived-games-list ${screenSize}`}>
            {
              (gamesToDisplay) &&
              gamesToDisplay
                .sort((a, b) => a.gameName.toLowerCase() > b.gameName.toLowerCase() ? 1 : -1)
                .map(g => {
                  return (
                    <div key={g.gameId} className='archived-game-item g-list-item'>
                      <div className='archived-game-icon'>
                        <ImageContainer
                          src={g.icon}
                          alt={g.gameName} />
                      </div>
                      <div className='archived-game-name'>
                        {g.gameName}
                      </div>
                      <div className='archived-game-date meta'>
                        Elements: {g.createdElementTotal ?? 0}<br />
                        Players: {g.playerCount ?? 0}<br />

                        Archived: {new Date(g.ts_archived).toLocaleDateString()}
                      </div>
                      <div className='buttons'>
                        <button
                          className='g-button med-btn'
                          onClick={() => navigate(g.path)}>View</button>
                        <button
                          className='g-button med-btn'
                          onClick={() => reinstateGame(g.gameId)}>
                          Reinstate
                        </button>
                      </div>
                    </div>
                  )
                })
            }
          </div>
        </div>
        <div className="g-space-1"></div>
      </div>
      <ModalAlert
        show={alertMessage}
        message={alertMessage}
        cancel={() => setAlertMessage(false)}
      />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(false)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <FullPageLoader show={loading} />
    </div>
  )
}

export default ArchivedGamesContainer